/**
 * useLingerAfterClose.ts — окно в странице ещё на время затухания (WEB-3754
 * юнит 4, доводка 2, сверка вида, находка 1).
 *
 * Окно кита (`Modal`) закрывается плавно: при `open` из `true` в `false` —
 * класс `out` и `close()` через `MODAL_OUT_MS`. Окна доменов монтировались
 * условием «открыто» и снимались со страницы сразу — анимация не успевала
 * начаться. Хук отвечает `true`, пока `open` истинно, и ещё `MODAL_OUT_MS`
 * после перехода в ложь; открыли снова раньше конца — таймер снят, ответ
 * остаётся `true`; размонтирование снимает таймер. Своей анимации нет: окно
 * получает `open={false}` и просто живёт до конца затухания кита.
 */
import { useEffect, useState } from 'react';
import { MODAL_OUT_MS } from '@/components/kit/ds/Modal';

export function useLingerAfterClose(open: boolean): boolean {
  const [shown, setShown] = useState(open);

  useEffect(() => {
    if (open) {
      setShown(true);
      return undefined;
    }
    const t = setTimeout(() => setShown(false), MODAL_OUT_MS);
    return () => clearTimeout(t);
  }, [open]);

  return open || shown;
}
